import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import withPagination from './WithSmallerPagination';
import LoadingDataEnhancer from './LoadingData';
import ExternalTransactionsList from '../views/ExternalTransactions/List';
import Search from '../views/Shared/Search';
import externalAuctionTransactionsQuery from '../graphql/externalAuctionTransactionsQuery';
import { setSearch, clearSearch } from '../data/searchField/actions';
import { setPage } from '../data/page/actions';

import { setRefreshSearch } from '../data/refreshSearch/actions';

const ExternalTransactions = props => {
  const {
    clearSearchFields,
    dispatchRefreshSearch,
    refreshSearch,
    data: { externalAuctionTransactions, refetch, fetchMore },
    setSearchFields: setSearchFieldsAction,
    setPage: setPageAction,
    location: { state },
    searchFields,
  } = props;

  useEffect(() => {
    if (refreshSearch) {
      dispatchRefreshSearch(false);
      clearSearchFields({});
      const variableArguments = {
        vin: null,
        dealerNumber: null,
      };
      refetch({
        ...variableArguments,
      });
    }
  }, [refreshSearch, dispatchRefreshSearch, clearSearchFields, refetch]);

  useEffect(() => {
    if (!isEmpty(state)) {
      const { vin } = state;
      const vinVariable = { vin };
      fetchMore({
        variables: {
          ...vinVariable,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => fetchMoreResult,
      });
    }
  }, [state, fetchMore]);

  const onSearchSubmitHandler = useCallback(event => {
    const { vin, dealerNumber } = event.target;
    const dealerNos = isEmpty(dealerNumber.value) ? null : dealerNumber.value;
    const variableArguments = {
      vin: vin.value || null,
      dealerNumber: dealerNos,
    };
    refetch({
      ...variableArguments,
    });

    setSearchFieldsAction(variableArguments);
    setPageAction({});
  }, [refetch, setSearchFieldsAction, setPageAction]);

  const vin = !isEmpty(state) ? state.vin : '';

  return (
    <div>
      <Search
        onSubmit={onSearchSubmitHandler}
        searchFields={searchFields}
        searchOptions={['vin', 'dealerNumber']}
        vin={vin}
      />

      <ExternalTransactionsList
        externalAuctionTransactions={externalAuctionTransactions}
      />
    </div>
  );
};

ExternalTransactions.propTypes = {
  clearSearchFields: PropTypes.func.isRequired,
  dispatchRefreshSearch: PropTypes.func.isRequired,
  refreshSearch: PropTypes.bool,
  data: PropTypes.shape({
    externalAuctionTransactions: PropTypes.array,
    refetch: PropTypes.func,
    fetchMore: PropTypes.func,
  }).isRequired,
  setSearchFields: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      vin: PropTypes.string,
    }),
  }).isRequired,
  searchFields: PropTypes.object.isRequired,
};

ExternalTransactions.defaultProps = {
  refreshSearch: false,
};

const mapDispatchToProps = dispatch => ({
  setSearchFields: fields => {
    dispatch(setSearch(fields));
  },
  clearSearchFields: () => {
    dispatch(clearSearch());
  },
  setPage: () => {
    dispatch(setPage());
  },
  dispatchRefreshSearch: value => {
    dispatch(setRefreshSearch(value));
  },
});

const mapStateToProps = state => {
  const { data: { searchFields, refreshSearch } } = state;
  return {
    searchFields,
    refreshSearch,
  };
};

export default compose(
  withRouter,
  withPagination(
    externalAuctionTransactionsQuery,
    'externalAuctionTransactions'
  ),
  LoadingDataEnhancer,
  connect(mapStateToProps, mapDispatchToProps)
)(ExternalTransactions);
